<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-cancel
            </v-icon>
          </v-btn>
        </template>
        <span>Cancel Applications</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="warning"
      title="Cancel Leave Applications"
      text="Cancel Leave Applications"
      class="mb-0"
    >
      <v-card-text> Are you sure you want to cancel this leave application? </v-card-text>
   
      <v-row no-gutters>
        <v-col cols="12">
          <helper-file-input
            v-model="file"
            v-validate="'required'"
            :max-size-in-mb="10"
            :max-number="5"
            :multiple="true"
            data-vv-name="files"
            field-name="files"
            accept-type=".pdf"    
            extension="ext:pdf"         
          >
            <div 
              slot="activator"
              class="mb-2"
            >   
              <v-row>
                <v-col>
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf only)' }}
                  </span>
                </v-col>
                <v-col
                  v-if="file"
                  cols="10"
                  class="pl-4"
                >
                  <div
                    v-for="(selectedFile) in file.selectedFiles"
                    :key="selectedFile.name"
                    class="font-weight-bold"
                  >
                    {{ selectedFile.name }}
                  </div>
                </v-col>
              </v-row>
            </div>
          </helper-file-input>
          <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
        </v-col>
      </v-row>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      application: {
        type: Object,
        default: null,
      },    
    },
    data () {
      return {
        dialog: false,
        progressing: false, 
        file: null,
      }
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.entitlementLeaveApplications().cancel(this.application.id, this.prepareFormData())
              .then(res => {
                this.$snack({ message: res.data.status })
                this.$emit('cancel')
                this.dialog = false
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        if (this.file) {
          this.file.formData.set('leave_application_id', this.application.id)

          return this.file.formData
        }

        let formData = new FormData()
        formData.append('leave_application_id', this.application.id)

        return formData
      },
    },
  }
</script>
